import { origins } from 'z-js-commons';

import * as types from '../constants/ActionTypes';
import { groupByName, translateItemTypesName } from '../lib/ExerciseUtils';

export const initialState = {
    errorMsgSpecialExercise: '',
    errorMsgSpecialHomework: '',
    homeworkFavouriteOnly: false,
    filters: {
        favouriteOnly: false,
        itemTypes: [],
        origins: [],
        subjects: []
    },
    specialSearchIdList: [],
    specialSearchTerm: '',
    itemTypesListSpecial: [],
    loaded: true,
    originsListSpecial: [],
    showExercisesFavouriteToggle: false,
    specialContentTaxonomy: [],
    searchPage: 1,
    specialExercises: [],
    specialExercisesCount: 0,
    specialHomeworkCount: 0,
    specialHomeworkPage: 1,
    specialHomeworks: [],
    specialItemTypesListLoaded: true,
    specialOriginsListLoaded: true,
    specialSubjectsListLoaded: true,
    subjectsListSpecial: []
};

export default function Special(state = initialState, action = {}) {
    switch (action.type) {
        case types.GET_SPECIAL_EXERCISES:
            return {
                ...state,
                errorMsgSpecialExercise: '',
                loaded: false,
                searchPage: 1,
                specialExercises: [],
                specialExercisesCount: 0,
                filters: action.filters
            };
        case types.GET_SPECIAL_EXERCISES_SUCCESS:
            if (action.result.length < 1) {
                return {
                    ...state,
                    errorMsgSpecialExercise: 'La ricerca non ha prodotto alcun risultato.',
                    loaded: true,
                    specialExercisesCount: action.totalCount,
                    showExercisesFavouriteToggle: !!action.favourites
                };
            } else {
                return {
                    ...state,
                    loaded: true,
                    specialExercises: action.result,
                    specialExercisesCount: action.totalCount,
                    showExercisesFavouriteToggle: true
                };
            }
        case types.GET_MORE_SPECIAL_EXERCISES:
            return {
                ...state,
                loaded: false
            };
        case types.GET_MORE_SPECIAL_EXERCISES_SUCCESS:
            return {
                ...state,
                specialExercises: state.specialExercises.concat(action.result),
                loaded: true,
                showExercisesFavouriteToggle: true,
                searchPage: action.specialExercisePage
            };
        case types.GET_SPECIAL_EXERCISES_UNAUTHORIZED:
        case types.GET_SPECIAL_EXERCISES_FAILURE:
            return {
                ...state,
                errorMsgSpecialExercise: action.error,
                showExercisesFavouriteToggle: false,
                loaded: true
            };
        case types.GET_SPECIAL_SUBJECTS_LIST:
            return {
                ...state,
                specialSubjectsListLoaded: false,
                subjectsListSpecial: []
            };
        case types.GET_SPECIAL_SUBJECTS_LIST_SUCCESS:
            return {
                ...state,
                specialSubjectsListLoaded: true,
                subjectsListSpecial: !Array.isArray(action.result) ? [] : groupByName(action.result)
            };
        case types.GET_SPECIAL_SUBJECTS_LIST_UNAUTHORIZED:
        case types.GET_SPECIAL_SUBJECTS_LIST_FAILURE:
            return {
                ...state,
                specialSubjectsListLoaded: true
            };
        case types.GET_SPECIAL_ITEMTYPES_LIST:
            return {
                ...state,
                specialItemTypesListLoaded: false,
                itemTypesListSpecial: []
            };
        case types.GET_SPECIAL_ITEMTYPES_LIST_SUCCESS:
            let itemTypesName = [];
            if (Array.isArray(action.result)) {
                action.result.map(el => {
                    if (el.name.startsWith('exercise.') && el.name !== 'exercise.checker') {
                        return itemTypesName.push({ id: el.id, name: translateItemTypesName(el.name) });
                    } else {
                        return undefined;
                    }
                });
                itemTypesName.sort((a, b) => {
                    let textA = a.name.toUpperCase();
                    let textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            }
            return {
                ...state,
                specialItemTypesListLoaded: true,
                itemTypesListSpecial: itemTypesName
            };
        case types.GET_SPECIAL_ITEMTYPES_LIST_UNAUTHORIZED:
        case types.GET_SPECIAL_ITEMTYPES_LIST_FAILURE:
            return {
                ...state,
                specialItemTypesListLoaded: true
            };
        case types.GET_SPECIAL_ORIGINS_LIST:
            return {
                ...state,
                specialOriginsListLoaded: false,
                originsListSpecial: []
            };
        case types.GET_SPECIAL_ORIGINS_LIST_SUCCESS:
            return {
                ...state,
                specialOriginsListLoaded: true,
                originsListSpecial: !Array.isArray(action.result) ? [] : action.result.map(origin => origins.getOriginLabelObj(origin))
            };
        case types.GET_SPECIAL_ORIGINS_LIST_UNAUTHORIZED:
        case types.GET_SPECIAL_ORIGINS_LIST_FAILURE:
            return {
                ...state,
                specialOriginsListLoaded: true
            };
        case types.GET_SPECIAL_CONTENT_TAXONOMY:
            return {
                ...state,
                loadedSpecialContentTaxonomy: false,
                specialContentTaxonomy: []
            };
        case types.GET_SPECIAL_CONTENT_TAXONOMY_SUCCESS:
            return {
                ...state,
                loadedSpecialContentTaxonomy: true,
                specialContentTaxonomy: !Array.isArray(action.result) ? [] : action.result
            };
        case types.GET_SPECIAL_CONTENT_TAXONOMY_FAILURE:
            return {
                ...state,
                loadedSpecialContentTaxonomy: true
            };
        case types.GET_SPECIAL_HOMEWORKS_LIST:
            return {
                ...state,
                errorMsgSpecialHomework: '',
                homeworkFavouriteOnly: action.payload.favouriteOnly,
                loaded: false,
                specialHomeworkCount: 0,
                specialHomeworkPage: 1,
                specialHomeworks: []
            };
        case types.GET_SPECIAL_HOMEWORKS_LIST_SUCCESS:
            if (action.payload.result.length < 1) {
                return {
                    ...state,
                    loaded: true,
                    specialHomeworkCount: 0,
                    specialHomeworks: []
                };
            } else {
                return {
                    ...state,
                    loaded: true,
                    specialHomeworks: action.payload.result,
                    specialHomeworkCount: action.payload.totalCount
                };
            }
        case types.GET_SPECIAL_HOMEWORKS_LIST_UNAUTHORIZED:
        case types.GET_SPECIAL_HOMEWORKS_LIST_FAILURE:
            return {
                ...state,
                errorMsgSpecialHomework: action.error,
                loaded: true
            };
        case types.GET_MORE_SPECIAL_HOMEWORKS_LIST: {
            return {
                ...state,
                errorMsgSpecialHomework: '',
                homeworkFavouriteOnly: action.payload.favouriteOnly,
                loaded: false
            };
        }
        case types.GET_MORE_SPECIAL_HOMEWORKS_LIST_SUCCESS: {
            return {
                ...state,
                errorMsgSpecialHomework: '',
                loaded: true,
                specialHomeworks: state.specialHomeworks.concat(
                    action.payload.result.map(specialHomework => ({
                        ...specialHomework
                    }))
                ),
                specialHomeworkPage: action.payload.specialHomeworkPage
            };
        }
        case types.GET_MORE_SPECIAL_HOMEWORKS_LIST_FAILURE: {
            return {
                ...state,
                errorMsgSpecialHomework: action.error,
                loaded: true
            };
        }
        case types.EXERCISES_SPECIAL_FILTERS_CHANGE: {
            return {
                ...state,
                specialSearchIdList: action.searchIdList,
                specialSearchTerm: action.searchTerm,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            };
        }
        default:
            return state;
    }
}
